// 目标主表
import http from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 分页查询-tr
export function getMainReportList(data) {
    return http({
        url: apiCrmHost + '/goal/info/page',
        method: 'post',
        data
    });
};
// 导入-tr
export function importMainReportList(data) {
    return http({
        url: apiCrmHost + '/goal/info/import',
        method: 'post',
        data
    });
};
// 删除-tr
export function deleteMainReportList(data) {
    return http({
        url: apiCrmHost + '/goal/info/deleteBatch',
        method: 'post',
        data
    });
};
// 导出-tr
export function exportMainReportList(data) {
    return http({
        url: apiCrmHost + '/goal/info/export',
        method: 'post',
        data
    });
};
